module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/school-desk-double/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/school-desk-double/wood.jpg
// module id = 181
// module chunks = 0